import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { auth } from '../../backend/firebase'

import './Login.scss'

interface IAuthErr {
  code: string
  message: string
}

const toPascalCase = (s: string) => s.replace(/\w\S*/g, (m) => m.charAt(0).toUpperCase() + m.substr(1).toLowerCase())

const Login = () => {
  const history = useHistory()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const signIn = async (e: any) => {
    try {
      e.preventDefault()
      const params = new URLSearchParams(history.location.search)
      const redirectTo = params.get('redirectTo') || '/'
      const { user } = await auth.signInWithEmailAndPassword(email, password)

      const username = user?.email?.split('@')[0] || 'User'
      toast.success(`Welcome, ${toPascalCase(username)}`, { autoClose: 2000 })
      history.push(redirectTo)
    } catch (err: any) {
      const e = err as IAuthErr
      toast.error(e.message)
    }
  }

  const register = async (e: any) => {
    try {
      e.preventDefault()
      const authRes = await auth.createUserWithEmailAndPassword(email, password)
      // it successfully created a new user with email and password
      if (authRes) history.push('/')
    } catch (err: any) {
      const e = err as IAuthErr
      toast.error(e.message)
    }
  }

  return (
    <div className='login'>
      <Link to='/'>
        <img
          className='login__logo'
          src='https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png'
        />
      </Link>

      <div className='login__container'>
        <h1>Sign-in</h1>

        <form>
          <h5>E-mail</h5>
          <input type='text' value={email} onChange={(e) => setEmail(e.target.value)} />

          <h5>Password</h5>
          <input type='password' value={password} onChange={(e) => setPassword(e.target.value)} />

          <button type='submit' onClick={signIn} className='login__signInButton'>
            Sign In
          </button>
        </form>

        <p>
          By signing-in you agree to the AMAZON FAKE CLONE Conditions of Use & Sale. Please see our Privacy Notice, our
          Cookies Notice and our Interest-Based Ads Notice.
        </p>

        <button onClick={register} className='login__registerButton'>
          Create your Amazon Account
        </button>
      </div>
    </div>
  )
}

export default Login
